export default "__VITE_ASSET__d8e6a0fb__"